<template>
  <div class="container-fluid">
    <!-- Title -->
    <div class="row flex-row justify-content-between">
      <div class="mb-4">
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Income Statement
        </div>
        <div class="s-14 py-0 text-dak">
          {{ branchItem ? branchItem.parentNames : "" }}
        </div>
      </div>
      <div class="c-pointer">
        <el-dropdown trigger="click" class="w-100">
          <div class="d-flex default-btn text-dark w-100" size="large">
            <span class="mt-1 s-14 text-head" style="color: #0040ff"
              >Export</span
            >
            <div class="mt-0 ml-1">
              <el-icon :size="10" class="el-icon--right primary--text"
                ><ArrowDownBold
              /></el-icon>
            </div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(bookType, index) in bookTypeList"
                :key="index"
              >
                <a
                  v-if="selectedTab === 'summary'"
                  class="no-decoration text-dark"
                  @click="downloadFile1(bookType)"
                >
                  {{ bookType.name }}
                </a>
                <a
                  v-if="selectedTab === 'summaryAccount'"
                  class="no-decoration text-dark"
                  @click="downloadFile2(bookType)"
                >
                  {{ bookType.name }}
                </a>
                <a
                  v-if="selectedTab === 'details'"
                  class="no-decoration text-dark"
                  @click="downloadFile3(bookType)"
                >
                  {{ bookType.name }}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="row bg-gray-300 justify-content-center py-3 border-radius-8">
      <div
        class="col-md-12 my-2"
        v-if="branchItem && branchItem.parentNames == ''"
      >
        <el-tree-select
          v-model="selectedTree"
          class="w-100 cursor-pointer"
          placeholder="Select branch"
          :data="branchMappedTree"
          :render-after-expand="false"
          :filter-node-method="filterNodeMethod"
          @change="setBranchValue"
          filterable
          check-strictly
        />
      </div>
      <div class="col-md-12 pl-4">
        <div class="row align-items-center">
          <div class="col-md-8 col-12">
            <div class="row align-items-center">
              <div class="col-md-3 col-12">
                <div class="text-md-rigt text-left s-14 fw-400 text-dak">
                  Date Range
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="endDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div
              class="col-md-12 mt-3 d-flex justify-content-center justify-content-md-end px-0"
            >
              <el-button
                class="c-pointer w-100"
                :color="primarycolor"
                :loading="loading"
                round
                @click="generateReport"
              >
                Generate Report
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="text-center">
          <div class="row justify-content-center">
            <div
              class="col-md-10 d-flex justify-content-between align-items-end"
            >
              <div class="fw-400 s-14 text-dak">
                <span>Income</span>
                <div class="s-24 font-weight-600 text-head text-dak">
                  {{ currentUser.currencySymbol }}
                  {{
                    Math.abs(
                      incomeStatementData &&
                        incomeStatementData.incomeStatementSummary
                        ? incomeStatementData.incomeStatementSummary.totalIncome
                        : ""
                    ).toLocaleString()
                  }}
                </div>
              </div>
              <span>-</span>
              <div class="fw-400 s-14 text-dak">
                <span>Expenses</span>
                <div class="s-24 font-weight-600 text-head text-dak">
                  {{ currentUser.currencySymbol }}
                  {{
                    Math.abs(
                      incomeStatementData &&
                        incomeStatementData.incomeStatementSummary
                        ? incomeStatementData.incomeStatementSummary
                            .totalExpense
                        : ""
                    ).toLocaleString()
                  }}
                </div>
              </div>
              <span>=</span>
              <div class="fw-400 s-14 text-dak">
                <span>Net Balance</span>
                <div
                  v-if="
                    incomeStatementData &&
                    incomeStatementData.incomeStatementSummary
                  "
                  :style="{
                    color:
                      incomeStatementData.incomeStatementSummary.netBalance < 0
                        ? 'red'
                        : '#088c35',
                  }"
                  class="s-24 text-head font-weight-600"
                >
                  {{ currentUser.currencySymbol }}
                  {{
                    Math.abs(
                      incomeStatementData &&
                        incomeStatementData.incomeStatementSummary
                        ? incomeStatementData.incomeStatementSummary.netBalance
                        : ""
                    ).toLocaleString()
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="d-flex justify-content-center mt-5 cursor-pointer">
          <div
            style="background: #e0f2ff"
            class="p-1 d-flex align-items-center border-radius-8"
          >
            <div
              v-for="tab in tabs"
              :key="tab.id"
              style="color: #08162e"
              class="s-12 px-3"
              :class="{ active: selectedTab === tab.id }"
              @click="handleTabClick(tab.id)"
            >
              {{ tab.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="element-to-print"
      class="row mt-5"
      v-if="selectedTab === 'summary'"
    >
      <div class="col-md-12 px-0 d-flex flex-wrap">
        <div class="col-md-6">
          <IncomeStatmentColumnChart
            domId="chart1"
            title=""
            distance="5"
            subtitle=""
            :titleMargin="10"
            :data="chartData"
            :series="chartSeries"
            yAxisText="Amount"
          />
        </div>
        <div class="col-md-6 mt-3 mt-md-0">
          <IncomeStatementPieChart
            v-if="selectedTab === 'summary'"
            domId="chart"
            title=""
            :summary="pieChartData"
          />
        </div>
      </div>
      <div class="col-md-12 px-0">
        <IncomeStatementSummary
          :endDate="endDate"
          :startDate="startDate"
          :incomeStatementSummaryData="incomeStatementData"
          :bookType="bookTypeItem1"
          :fileHeaderToExport="fileHeaderToExport"
          :fileToExport="fileToExport"
          :fileName="fileName"
          @download-complete="handleDownloadComplete"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 px-0" v-if="selectedTab === 'summaryAccount'">
        <IncomeAccountStatementSum
          :bookType="bookTypeItem2"
          :fileHeaderToExport="fileHeaderToExport"
          :fileToExport="fileToExport"
          :fileName="fileName"
          @download-complete="handleDownloadComplete"
          :endDate="endDate"
          :startDate="startDate"
          :incomeStatementSummaryData="incomeStatementData"
        />
      </div>
    </div>
    <!-- Accounts Table -->
    <div
      class="mt-3 row"
      v-if="selectedTab === 'details'"
      id="element-to-print"
    >
      <div
        class="container-fluild table-main remove-styles2 remove-border responsiveness"
      >
        <div class="row" v-if="bookTypeItem3 == 'pdf'">
          <div
            class="col-md-12 px-0 d-none"
            :class="{ 'd-none': bookTypeItem3 == 'pdf' }"
          >
            <table
              id="table"
              class="table remove-styles mt-0 col-md-12 table-hover table-header-area"
            >
              <thead>
                <tr>
                  <th>
                    <div class="row">
                      <div class="col-md-12 d-flex justify-content-between">
                        <div>
                          <div class="s-20 fw-500">
                            Income Statement(Profit & Loss)
                          </div>
                          <div class="s-18 font-weight-600">
                            {{ tenantDisplayName }}
                          </div>
                          <div class="s-18 fw-500">
                            <span class="mr-1"> Date Range: </span>
                            <span>
                              {{ formatDate(startDate) }}
                              to {{ formatDate(endDate) }}
                            </span>
                          </div>
                        </div>
                        <div>
                          <img
                            :src="churchLogo"
                            v-if="churchLogo"
                            class="link-image mr-2"
                            alt=""
                          />
                          <img
                            src="../../../../assets/dashboardlinks/churchcloud.png"
                            v-else
                            class="link-image mr-2"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <table
          id="table"
          class="table remove-styles mt-0 table-hover table-header-area"
        >
          <thead class="table-header-ar">
            <tr class="font-weight-bold">
              <th>ACCOUNTS</th>
              <th class="text-right"></th>
              <th class="text-right">
                <div class="text-dak s-14">{{ formatDate(startDate) }}</div>
                <div class="text-dak s-14">to {{ formatDate(endDate) }}</div>
              </th>
            </tr>
          </thead>
          <!-- <template
              
            > -->
          <tbody
            v-for="(group, category) in groupedTransactions"
            :key="category"
          >
            <tr class="category-header">
              <td colspan="3" class="table-header-area-main fw-400 s-14">
                <div>{{ category }}</div>
              </td>
            </tr>
            <tr v-for="(item, index) in group" :key="`${category}-${index}`">
              <td>
                <div class="font-weight-medium">{{ item.accountName }}</div>
                <div class="text-muted small">{{ item.description }}</div>
              </td>
              <td class="text-right">{{ formatDate(item.date) }}</td>
              <td class="text-right">
                {{ item.currency?.symbol || currentUser.currencySymbol }}
                {{ formatAmount(item.amount) }}
              </td>
            </tr>
            <tr class="total-row">
              <td class="font-weight-bold">Total {{ category }}</td>
              <td></td>
              <td class="text-right font-weight-bold">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(categoryTotals[category]) }}
              </td>
            </tr>
          </tbody>
          <!-- </template> -->

          <!-- Net Total -->
          <tbody>
            <tr class="table-header-area-main fw-400 s-14">
              <td class="font-weight-bold">Net Balance</td>
              <td></td>
              <td class="text-right font-weight-bold">
                {{ currentUser.currencySymbol }} {{ formatAmount(netTotal) }}
              </td>
            </tr>
          </tbody>
          <div class="mt-4"></div>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, watchEffect, inject } from "vue";
import IncomeStatementPieChart from "@/components/charts/ReportPieChart.vue";
import IncomeStatmentColumnChart from "../../../../components/charts/ReportColumnChart.vue";
// import exportService from "../../../services/exportFile/exportservice";
import exportService from "../../../../services/exportFile/exportserjs";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";
import IncomeAccountStatementSum from "../../../Reports/Financialreport/IncomeAccountStatementSum.vue";
import IncomeStatementSummary from "./IncomeStatementSummary.vue";
import incomeExpenseHelper from "../../../Reports/Financialreport/Helper/Incomeexpenses-helper";
import dateFormatter from "../../../../services/dates/dateformatter";
import { ElNotification } from "element-plus";
import { useRoute } from "vue-router";

// Date & Filters
const startDate = ref(
  new Date().setFullYear(new Date().getFullYear() - 1)
    ? new Date().setFullYear(new Date().getFullYear() - 1)
    : ""
);
const endDate = ref(new Date(Date.now()));
const loading = ref(false);
const primarycolor = inject("primarycolor");
// const displayTitle = ref(false);
const route = useRoute();
const tableData = ref({});
const incomeStatementData = ref({});
const incomeStatement = ref([]);
const fileName = ref("Income Statment Report");
const bookTypeList = ref([
  { name: "xlsx" },
  { name: "csv" },
  { name: "txt" },
  { name: "pdf" },
]);
// const selectedFileType = ref({});
const fileHeaderToExport = ref([]);
const selectedTree = ref(null);
const branchMappedTree = ref([]);
const flattenedTree = ref([]);
const fileToExport = ref([]);
const bookTypeItem1 = ref("");
const bookTypeItem2 = ref("");
const bookTypeItem3 = ref("");
const showReport = ref(false);
const store = useStore();
const selectedTab = ref("summary");
const chartForIcomeAndExpense = ref([]);
const transactions = ref([]);
const tenantData = ref({});
const churchLogo = ref("");
const tabs = [
  { id: "summary", label: "Summary" },
  { id: "summaryAccount", label: "Account Summary" },
  { id: "details", label: "Details" },
];

const branchItem = ref({});
branchItem.value = JSON.parse(localStorage.getItem("branchItem"));

const handleTabClick = async (tabId) => {
  selectedTab.value = tabId;

  // Only refresh data when switching to summary tab
  if (
    tabId === "summary" ||
    tabId === "summaryAccount" ||
    tabId === "details"
  ) {
    await getReport();
  }
};

const handleDownloadComplete = (success) => {
  if (success) {
    ElNotification.success({ message: "Export completed!" });
  } else {
    ElNotification.error({ message: "Export failed!" });
  }
};

const formatDate = (date) => {
  return dateFormatter.monthDayYear(date);
};
const buildTreeAndFlatten = (data) => {
  const tree = [];
  const flat = [];

  const map = new Map();
  data.forEach((item) => {
    const node = {
      id: item.id,
      value: item.id, // for v-model binding
      label: item.name,
      parentID: item.parentID,
      children: [],
    };
    map.set(item.id, node);
    flat.push({
      label: node.label,
      value: node.value,
      parentID: item.parentID,
    }); // for quick lookup
  });

  for (const node of map.values()) {
    if (
      !node.parentID ||
      node.parentID === "00000000-0000-0000-0000-000000000000"
    ) {
      tree.push(node);
    } else {
      const parent = map.get(node.parentID);
      if (parent) {
        parent.children.push(node);
      } else {
        tree.push(node); // orphan fallback
      }
    }
  }

  flattenedTree.value = flat;
  return tree;
};
const getHierarchy = async () => {
  try {
    const { data } = await axios.get(
      "/api/Branching/GetBranchesLeanInformation"
    );
    const list = data.returnObject || [];
    branchMappedTree.value = buildTreeAndFlatten(list);
  } catch (error) {
    console.log("Error loading hierarchy", error);
  }
};
getHierarchy();
const setBranchValue = () => {
  const response = flattenedTree.value.find(
    (i) => i.value == selectedTree.value
  );
  // const res = allBranchDetail.value.filter(
  //   (item) => item.parentID === response.parentID
  // );
  console.log(response, "hhhhj");
};

const filterNodeMethod = (value, data) =>
  data.label.toLowerCase().includes(value.toLowerCase());

const groupedTransactions = computed(() => {
  const groups = {};
  transactions.value.forEach((transaction) => {
    if (!groups[transaction.accountCategory]) {
      groups[transaction.accountCategory] = [];
    }
    groups[transaction.accountCategory].push(transaction);
  });
  return groups;
});

// Calculate totals for each category
const categoryTotals = computed(() => {
  const totals = {};
  for (const category in groupedTransactions.value) {
    totals[category] = groupedTransactions.value[category].reduce(
      (sum, item) => sum + Math.abs(item.amount),
      0
    );
  }
  return totals;
});

// Calculate net total
const netTotal = computed(() => {
  return Object.values(categoryTotals.value).reduce(
    (total, amount, index) => (index === 0 ? amount : total - amount),
    0
  );
});

const downloadFile1 = async (item) => {
  if (selectedTab.value === "summary") bookTypeItem1.value = null;
  await nextTick();
  bookTypeItem1.value = item.name;
};
const downloadFile2 = async (item) => {
  if (selectedTab.value === "summaryAccount") bookTypeItem2.value = null;
  await nextTick();
  bookTypeItem2.value = item.name;
};
const downloadFile3 = async (item) => {
  bookTypeItem3.value = item.name;
  await nextTick();
  exportService.downLoadExcel(
    item.name,
    document.getElementById("element-to-print"),
    fileName.value,
    fileHeaderToExport.value,
    fileToExport.value
  );
  ElNotification.success({ message: "Export completed!" });
};
const tenantDisplayName = computed(() => {
  if (!tenantData.value.churchName) return "";
  const name =
    tenantData.value.churchName.length < 20
      ? tenantData.value.churchName
      : `${tenantData.value.churchName.slice(0, 20)}...`;
  return name;
});
const getChurchProfile = async () => {
  try {
    let { data } = await axios.get(
      `/GetChurchProfileById?tenantId=${getUser.value.tenantId}`
    );
    churchLogo.value = data.returnObject.logo;
  } catch (err) {
    console.error(err);
  }
};
const getUser = computed(() => {
  if (
    !store.getters.currentUser ||
    (store.getters.currentUser &&
      Object.keys(store.getters.currentUser).length == 0)
  )
    return "";
  return store.getters.currentUser;
});
watchEffect(() => {
  if (getUser.value) {
    tenantData.value = getUser.value;
    getChurchProfile();
  }
});

const currentUser = computed(() => {
  if (store && Object.keys(store.getters.currentUser).length > 0)
    return store.getters.currentUser;
  return "";
});

const generateReport = async () => {
  loading.value = true;
  try {
    const { data } = await axios.get(
      `/api/Reports/financials/getIncomeStatementReport?startDate=${new Date(
        startDate.value
      ).toLocaleDateString("en-US")}&endDate=${new Date(
        endDate.value
      ).toLocaleDateString("en-US")}`
    );
    incomeStatementData.value = data;
    transactions.value = data.transactions.filter((t) => t !== null);
    tableData.value = incomeExpenseHelper.formatAccounts(data.transactions);
    incomeStatement.value = data.transactions.filter((i) => i !== null);

    if (incomeStatement.value.length > 0) {
      showReport.value = true;
    } else {
      showReport.value = false;
    }

    chartForIcomeAndExpense.value = data;
    loading.value = false;

    /* function to call service and populate table */
    setTimeout(() => {
      fileHeaderToExport.value = exportService.tableHeaderToJson(
        document.getElementsByTagName("th")
      );
      fileToExport.value = exportService.tableToJson(
        document.getElementById("table")
      );
    }, 1000);
    /* End function to call service and populate table */
    loading.value = false;
  } catch (error) {
    console.log(error);
    loading.value = false;
  }
};

const getReport = async () => {
  try {
    const { data } = await axios.get(
      `/api/Reports/financials/getIncomeStatementReport?startDate=${new Date(
        startDate.value
      ).toLocaleDateString("en-US")}&endDate=${new Date(
        endDate.value
      ).toLocaleDateString("en-US")}`
    );
    incomeStatementData.value = data;
    transactions.value = data.transactions.filter((t) => t !== null);
    tableData.value = incomeExpenseHelper.formatAccounts(data.transactions);
    incomeStatement.value = data.transactions.filter((i) => i !== null);

    if (incomeStatement.value.length > 0) {
      showReport.value = true;
    } else {
      showReport.value = false;
    }

    chartForIcomeAndExpense.value = data;

    setTimeout(() => {
      fileHeaderToExport.value = exportService.tableHeaderToJson(
        document.getElementsByTagName("th")
      );
      fileToExport.value = exportService.tableToJson(
        document.getElementById("table")
      );
    }, 1000);
    /* End function to call service and populate table */
    loading.value = false;
  } catch (error) {
    console.log(error);
  }
};
getReport();

const chartData = computed(() => {
  const incomeTotal = categoryTotals.value["Income"] || 0;
  const expenseTotal = categoryTotals.value["Expense"] || 0;

  return [
    {
      name: "Income",
      color: "#4CAF50", // Green for income
      data: [Math.abs(incomeTotal)],
    },
    {
      name: "Expense",
      color: "#F44336", // Red for expense
      data: [Math.abs(expenseTotal)],
    },
  ];
});

const chartSeries = computed(() => ["Total"]);
const pieChartData = computed(() => {
  let totalIncome = 0;
  let totalExpense = 0;

  transactions.value.forEach((t) => {
    if (t.accountCategory === "Income") {
      totalIncome += Math.abs(t.amount);
    } else if (t.accountCategory === "Expense") {
      totalExpense += Math.abs(t.amount);
    }
  });

  return [
    {
      name: "Income",
      value: totalIncome,
      color: "#4CAF50", // Green for income
    },
    {
      name: "Expense",
      value: totalExpense,
      color: "#F44336", // Red for expense
    },
  ];
});

// Format Amount
const formatAmount = (amount) =>
  amount.toLocaleString("en-NG", { minimumFractionDigits: 2 });
</script>

<style scoped>
.table th,
.table td {
  border-top: none;
}
.active {
  background: #ffffff;
  color: #08162e;
  font-weight: 700;
  /* width: 81px; */
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* padding: 15px 0; */
}
.bg-secondary {
  background-color: #f8f9fa !important;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  /* border: 0.063rem solid #dde2e6 !important; */
  /* border-radius: 30px !important; */
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}

.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
table tbody tr,
table thead tr {
  border-bottom: 1px solid rgba(0, 0, 1, 0.2);
}
table tbody tr:first-child {
  border-bottom: none !important;
}
table tbody tr:last-child {
  border-bottom: none !important;
}

.remove-border {
  box-shadow: none !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #d4dde4;
  /* background-color: #f4f4f4; */
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
